module.exports = __webpack_public_path__ + "media/Brother-in-law.60bd04ac.mp3";